function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import moment from "moment";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import { ActivityDetailContainer } from "../../components/container-activity";
import { SimpleContainer, CssContainer } from "../../components/container";
import { KpiStrip, Kpi } from '../../components/card';
import DynamicGrid from "../../components/dynamic-grid";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import ServiceFactory from "../../service";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import activityKeyValues from "../../functions/activity-key-values";
import paginate from "../../functions/paginate";
import keyValueStore from "../../store/keyvalue";
import { Button } from '@progress/kendo-react-buttons';
import FilterPopover from './filter-popover';
import csv from '../../functions/csv';
import replace from "../../functions/replace";
export class ActivityKeyValuesComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "syncToGlobal", () => {
      this.resolveDates(getGlobalRange()).then(d => {
        if (!this._alive || !d) return;
        var params = this.props.params;
        if (d.startDate === params.startDate && d.endDate === params.endDate) return; // already current
        this.gotoPage(this.getUrl(d.startDate, d.endDate));
      });
    });
    _defineProperty(this, "getUrl", (startDate, endDate) => {
      var params = this.props.params;
      var url = `/Activity/KeyValues/${params.type}/${params.name}/${startDate}/${endDate}`;
      return url;
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onFilterRequest", columnDisplay => {
      keyValueStore.saveColumnDisplay(columnDisplay);
      var url = this.url;
      this.gotoPage(url);
    });
    _defineProperty(this, "onExport", e => {
      var params = this.props.params;
      var startDate = params.startDate;
      var endDate = params.endDate;
      var type = params.type;
      var name = params.name;
      name = name.replace(/@/g, '-');
      var data = keyValueStore.get(startDate, endDate);
      var csvData = csv.generate(data.rows, data.columns);
      //console.log(csvData);
      var fileName = `${name}_${startDate}_${endDate}.csv`;
      download(csvData, fileName, "text/csv");
    });
  }

  // Date range now follows the GLOBAL top-bar period control. This view's URL
  // carries explicit start/end dates, so we resolve the global range token to
  // dates and keep the URL in sync (on mount + whenever the global period
  // changes). The old per-page picker is gone.
  componentDidMount() {
    this._alive = true;
    this.syncToGlobal();
    this._periodTok = subscribePeriod(() => {
      if (this._alive) this.syncToGlobal();
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }

  // Resolve the global range token to {startDate, endDate} (YYYY-MM-DD).
  // Custom tokens carry the dates; presets (incl. all_time) resolve server-side
  // via /metrics/date/{range}, the same endpoint the old picker used.
  resolveDates(range) {
    return new Promise(resolve => {
      var m = /^custom_(\d{8})_(\d{8})$/.exec(range || "");
      if (m) {
        resolve({
          startDate: moment(m[1], "YYYYMMDD").format("YYYY-MM-DD"),
          endDate: moment(m[2], "YYYYMMDD").format("YYYY-MM-DD")
        });
        return;
      }
      var Service = ServiceFactory.getType(`/metrics/date/${range}`);
      new Service().get({}, (err, data) => {
        if (err) {
          resolve(null);
          return;
        }
        resolve({
          startDate: moment(data.startDate).format("YYYY-MM-DD"),
          endDate: moment(data.endDate).format("YYYY-MM-DD")
        });
      });
    });
  }
  get url() {
    var params = this.props.params;
    var url = `/Activity/KeyValues/${params.type}/${params.name}/${params.startDate}/${params.endDate}`;
    return url;
  }
  get refreshUrl() {
    return this.url;
  }
  get baseUrl() {
    return this.url;
  }
  render() {
    var params = this.props.params;
    var data = this.props.data;
    var columns = this.props.columns;
    var columnDisplay = this.props.columnDisplay;
    var type = params.type;
    var name = params.name;
    name = name.replace(/@/g, ' ');
    var refreshUrl = this.refreshUrl;
    var baseUrl = this.baseUrl;
    var startDate = moment(params.startDate).format('LLL');
    var endDate = moment(params.endDate).format('LLL');
    var count = this.props.pagination.count;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActivityDetailContainer, {
      title: replace(type) + ' Details',
      id: "activity",
      hidePicker: true,
      onGoBack: this.onGoBack
    }, /*#__PURE__*/React.createElement("div", {
      className: "activity-detail-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "activity-detail-box"
    }, /*#__PURE__*/React.createElement("span", {
      className: "primary"
    }, name), /*#__PURE__*/React.createElement("div", {
      className: "small"
    }, "From ", startDate, " to ", endDate)), /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total",
      value: count
    })))), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement(FilterPopover, {
      onFilterRequest: this.onFilterRequest,
      columns: columns,
      columnDisplay: columnDisplay
    }), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onExport
    }, "Export ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_forward"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(DynamicGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      pagination: this.props.pagination,
      columns: columns,
      columnDisplay: columnDisplay,
      onPageRequest: this.onPageRequest
    })));
  }
}
export class ActivityKeyValuesViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  componentWillUnmount() {
    console.log('unmounting');
    keyValueStore.remove();
  }
  get api() {
    var params = this.props.params;
    var api = `/metrics/keyvalues/${params.type}/${params.name}/${params.startDate}/${params.endDate}`;
    return api;
  }
  get baseUrl() {
    var params = this.props.params;
    var baseUrl = `/Activity/KeyValues/${params.type}/${params.name}/${params.startDate}/${params.endDate}`;
    return baseUrl;
  }
  async fetchData() {
    var params = this.props.params;
    var startDate = params.startDate;
    var endDate = params.endDate;
    var result = keyValueStore.get(startDate, endDate);
    console.log(result);
    if (result) {
      this.paginateData(result);
    } else {
      await this.fetchRemoteData(startDate, endDate);
    }
  }
  paginateData(result) {
    console.log('paginate from store');
    var baseUrl = this.baseUrl;
    let page = this.page;
    var paginatedResult = paginate.get({
      baseUrl: baseUrl,
      rawUrl: location.href,
      page: page,
      pageSize: 10
    }, result.rows);
    this.pagination = paginatedResult.pagination;
    this.data = paginatedResult.data;
    this.columns = result.columns;
    this.columnDisplay = result.columnDisplay;
    this.allowRender = true;
    this.forceUpdate();
  }
  async fetchRemoteData(startDate, endDate) {
    console.log('fetching remote data');
    var api = this.api;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    var baseUrl = this.baseUrl;
    let page = this.page;
    try {
      let data = await service.getAsync();
      var result = activityKeyValues.parse(data.data.result);
      var paginatedResult = paginate.get({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: 10
      }, result.rows);
      this.pagination = paginatedResult.pagination;
      this.data = paginatedResult.data;
      this.columns = result.columns;
      this.columnDisplay = result.columnDisplay;
      keyValueStore.save(result, startDate, endDate);
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableActivityKeyValuesComponent, {
        data: this.data,
        columns: this.columns,
        columnDisplay: this.columnDisplay,
        pagination: this.pagination,
        params: this.props.params
      });
    }
  }
}
const RoutableActivityKeyValuesComponent = withRouter(ActivityKeyValuesComponent);
export default {
  ActivityKeyValuesViewComponent
};